import TopLogoPanel from "components/TopLogoPanel";
import Layout from "layouts";
import React from "react";
import LoginComponent from "./LoginComponent";

export default function Login() {
  return (
    <Layout variant="empty">
      <TopLogoPanel>
        <LoginComponent />
      </TopLogoPanel>
    </Layout>
  );
}
